/* src/app/features/purchase-requests/purchase-requests-list/centralized-purchase/centralized-purchase.component.css */
.head {
  display: flex;
  min-height: 173px;
  flex-direction: column;
  justify-content: space-between;
}
.records {
  margin-bottom: 2px;
}
.buttons {
  display: flex;
  margin-top: 50px;
}
.buttons > po-button {
  margin-right: 8px;
}
.wrapper {
  height: 0px;
}
.cart {
  cursor: pointer;
}
.actions-group-buttons {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  height: 46px;
}
.btn-quote {
  float: right;
  margin: 5px 5px 0 0;
}
.warning {
  color: #be3e37;
}
.alertForm {
  margin-bottom: 20px;
}
.footer {
  position: sticky;
  bottom: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-top: solid 2px rgba(128, 128, 128, 0.176);
  flex-wrap: nowrap;
}
/*# sourceMappingURL=centralized-purchase.component.css.map */
